import { render, staticRenderFns } from "./order.vue?vue&type=template&id=1b66ec92&"
import script from "@viewJs/reservation/order.js?vue&type=script&lang=js&"
export * from "@viewJs/reservation/order.js?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports